// Eventually we want to be able to coinfigure this stuff.

import { PermissionEnum, Role, RoleMapType } from './rolesAndPermissions';
export const _defaultRoleMap: RoleMapType = {
  OWNER: {
    OWNER: true,
    SHAREHOLDER: true,
    VIEW_SHARES: true,
    VIEW_SHARE_ISSUES: true,
    INITIATE_ORGBRAIN_SIGNING: true,
    INITIATE_BANK_ID_SIGNING: true,
    ALLOW_AI_TRANSCRIPTION: true,
    ACCESS_TO_GA_MEETINGS: true,
    ACCESS_TO_NEWS_FOR_SHAREHOLDERS: true,
    DATAROOM_COPY_FILE: true,
    DATAROOM_SEE_FILE_DETAILS: true,
    DATAROOM_CREATE_TASK_FROM_FILE: true,
    DATAROOM_SEE_FILE_MENU: true,
    DATAROOM_SET_FILE_STATUS: true,
    OPENAI_USER: true,
    files: true,
    news: true,
    shareholders: true,
    surveys: true,
    meetings: true,
    CONVERSATIONS_LIMITED: true,
    files_lite: true,
  },
  ADMIN: {
    ADMIN: true,
    SHAREHOLDER_ADMIN: true,
    DATAROOM_ADMIN: true,
    MEETING_ADMIN: true,
    GA_MEETING_ADMIN: true,
    BOARD_MEETING_ADMIN: true,
    TASKS_ADMIN: true,
    NEWS_ADMIN: true,
    GA_NEWS_ADMIN: true,
    ORGANIZATION_ADMIN: true,
    ACCESS_TO_BOARD_MEETINGS: true,
    ACCESS_TO_GA_MEETINGS: true,
    VIEW_SHARES: true,
    VIEW_SHARE_ISSUES: true,
    INITIATE_ORGBRAIN_SIGNING: true,
    INITIATE_BANK_ID_SIGNING: true,
    ALLOW_AI_TRANSCRIPTION: true,
    CREATE_SIGNING_ORDER: true,
    SEE_CYCLIC_CALENDAR: true,
    SEE_FOLLOWUP_CASES: true,
    SEE_MANAGE_SIGNATURES: true,
    SEE_USER_EMAILS: true,
    SEE_USER_NAMES: true,
    SELLER_ADMIN: true,
    SEE_ACTION_POINTS: true,
    SEE_ENTITY_SENSITIVE: true,
    BUYER_ADMIN: true,
    SELLER: true,
    BUYER: true,
    CREATE_DD_GROUP: true,
    CREATE_SUB_GROUP: true,
    ACCESS_TO_SECURITY_TAB: true,
    ACCESS_TO_SETTINGS_TAB: true,
    DATAROOM_DOWNLOAD_ZIP: true,
    ORGBRAIN_ACADEMY: true,
    DATAROOM_SEE_SHOW_DELETED: true,
    DATAROOM_COPY_FILE: true,
    DATAROOM_SEE_FILE_DETAILS: true,
    DATAROOM_SEE_FILE_HISTORY: true,
    DATAROOM_CREATE_TASK_FROM_FILE: true,
    DATAROOM_SEE_FILE_MENU: true,
    DATAROOM_SET_FILE_STATUS: true,
    TEMPLATES_ADMIN: true,
    ACCESS_TO_NEWS_FOR_BOARD: true,
    ACCESS_TO_NEWS_FOR_SHAREHOLDERS: true,
    OPENAI_USER: true,
    shareholders: true,
    templates: true,
    files: true,
    surveys: true,
    meetings: true,
    tasks: true,
    chat: true,
    school: true,
    news: true,
    organization: true,
    BOARDMATCH_ADMIN: true,
    CONVERSATIONS_CREATE: true,
    CONVERSATIONS_LIMITED: true,
    CONVERSATIONS_ADMIN: true,
    files_lite: true,
    MEETING_AI: true,
  },
  ADVISER: {
    ADMIN: true,
    SHAREHOLDER_ADMIN: true,
    DATAROOM_ADMIN: true,
    MEETING_ADMIN: true,
    GA_MEETING_ADMIN: true,
    BOARD_MEETING_ADMIN: true,
    TASKS_ADMIN: true,
    NEWS_ADMIN: true,
    GA_NEWS_ADMIN: true,
    ORGANIZATION_ADMIN: true,
    ACCESS_TO_BOARD_MEETINGS: true,
    ACCESS_TO_GA_MEETINGS: true,
    VIEW_SHARES: true,
    VIEW_SHARE_ISSUES: true,
    INITIATE_ORGBRAIN_SIGNING: true,
    INITIATE_BANK_ID_SIGNING: true,
    ALLOW_AI_TRANSCRIPTION: true,
    CREATE_SIGNING_ORDER: true,
    SEE_CYCLIC_CALENDAR: true,
    SEE_FOLLOWUP_CASES: true,
    SEE_MANAGE_SIGNATURES: true,
    SEE_USER_EMAILS: true,
    SEE_USER_NAMES: true,
    SELLER_ADMIN: true,
    SEE_ACTION_POINTS: true,
    SEE_ENTITY_SENSITIVE: true,
    BUYER_ADMIN: true,
    SELLER: true,
    BUYER: true,
    CREATE_DD_GROUP: true,
    CREATE_SUB_GROUP: true,
    ACCESS_TO_SECURITY_TAB: true,
    ACCESS_TO_SETTINGS_TAB: true,
    DATAROOM_DOWNLOAD_ZIP: true,
    ORGBRAIN_ACADEMY: true,
    DATAROOM_SEE_SHOW_DELETED: true,
    DATAROOM_COPY_FILE: true,
    DATAROOM_SEE_FILE_DETAILS: true,
    DATAROOM_SEE_FILE_HISTORY: true,
    DATAROOM_CREATE_TASK_FROM_FILE: true,
    DATAROOM_SEE_FILE_MENU: true,
    DATAROOM_SET_FILE_STATUS: true,
    TEMPLATES_ADMIN: true,
    ACCESS_TO_NEWS_FOR_BOARD: true,
    ACCESS_TO_NEWS_FOR_SHAREHOLDERS: true,
    OPENAI_USER: true,
    shareholders: true,
    templates: true,
    files: true,
    surveys: true,
    meetings: true,
    tasks: true,
    chat: true,
    school: true,
    news: true,
    organization: true,
    BOARDMATCH_ADMIN: true,
    CONVERSATIONS_CREATE: true,
    CONVERSATIONS_LIMITED: true,
    CONVERSATIONS_ADMIN: true,
    files_lite: true,
    MEETING_AI: true,
  },

  ONBOARD_SUPPORT: {
    ADMIN: true,
    SHAREHOLDER_ADMIN: true,
    DATAROOM_ADMIN: true,
    MEETING_ADMIN: true,
    GA_MEETING_ADMIN: true,
    BOARD_MEETING_ADMIN: true,
    TASKS_ADMIN: true,
    NEWS_ADMIN: true,
    GA_NEWS_ADMIN: true,
    ORGANIZATION_ADMIN: true,
    ACCESS_TO_BOARD_MEETINGS: true,
    ACCESS_TO_GA_MEETINGS: true,
    VIEW_SHARES: true,
    VIEW_SHARE_ISSUES: true,
    INITIATE_ORGBRAIN_SIGNING: true,
    INITIATE_BANK_ID_SIGNING: true,
    ALLOW_AI_TRANSCRIPTION: true,
    CREATE_SIGNING_ORDER: true,
    SEE_CYCLIC_CALENDAR: true,
    SEE_FOLLOWUP_CASES: true,
    SEE_MANAGE_SIGNATURES: true,
    SEE_USER_EMAILS: true,
    SEE_USER_NAMES: true,
    SELLER_ADMIN: true,
    SEE_ACTION_POINTS: true,
    SEE_ENTITY_SENSITIVE: true,
    BUYER_ADMIN: true,
    SELLER: true,
    BUYER: true,
    CREATE_DD_GROUP: true,
    CREATE_SUB_GROUP: true,
    ACCESS_TO_SECURITY_TAB: true,
    ACCESS_TO_SETTINGS_TAB: true,
    DATAROOM_DOWNLOAD_ZIP: true,
    ORGBRAIN_ACADEMY: true,
    DATAROOM_SEE_SHOW_DELETED: true,
    DATAROOM_COPY_FILE: true,
    DATAROOM_SEE_FILE_DETAILS: true,
    DATAROOM_SEE_FILE_HISTORY: true,
    DATAROOM_CREATE_TASK_FROM_FILE: true,
    DATAROOM_SEE_FILE_MENU: true,
    DATAROOM_SET_FILE_STATUS: true,
    TEMPLATES_ADMIN: true,
    ACCESS_TO_NEWS_FOR_BOARD: true,
    ACCESS_TO_NEWS_FOR_SHAREHOLDERS: true,
    OPENAI_USER: true,
    shareholders: true,
    templates: true,
    files: true,
    surveys: true,
    meetings: true,
    tasks: true,
    chat: true,
    school: true,
    news: true,
    organization: true,
    BOARDMATCH_ADMIN: true,
    CONVERSATIONS_LIMITED: true,
    CONVERSATIONS_CREATE: true,
    files_lite: true,
    MEETING_AI: true,
  },

  ORGBRAIN_SUPPORT: { files_lite: true },
  USER_ADMIN: {
    VIEW_SHARES: true,
    VIEW_SHARE_ISSUES: true,
    INITIATE_ORGBRAIN_SIGNING: true,
    INITIATE_BANK_ID_SIGNING: true,
    ALLOW_AI_TRANSCRIPTION: true,
    ORGANIZATION_ADMIN: true,
    SEE_USER_EMAILS: true,
    SEE_USER_NAMES: true,
    OPENAI_USER: true,
    organization: true,
    BOARDMATCH_ADMIN: true,
    CONVERSATIONS_LIMITED: true,
    CONVERSATIONS_CREATE: true,
    files_lite: true,
  },
  CHAIR: {
    ADMIN: true,
    NEWS_ADMIN: true,
    GA_NEWS_ADMIN: true,
    SHAREHOLDER_ADMIN: true,
    MEETING_ADMIN: true,
    GA_MEETING_ADMIN: true,
    BOARD_MEETING_ADMIN: true,
    TASKS_ADMIN: true,
    ORGANIZATION_ADMIN: true,
    CAN_VOTE_BOARDMEETING: true,
    CAN_VOTE_IN_THEORY_BOARDMEETING: true,
    ACCESS_TO_BOARD_MEETINGS: true,
    ACCESS_TO_GA_MEETINGS: true,
    ACCESS_TO_NEWS_FOR_BOARD: true,
    VIEW_SHARES: true,
    VIEW_SHARE_ISSUES: true,
    INITIATE_ORGBRAIN_SIGNING: true,
    INITIATE_BANK_ID_SIGNING: true,
    ALLOW_AI_TRANSCRIPTION: true,
    CREATE_SIGNING_ORDER: true,
    SEE_CYCLIC_CALENDAR: true,
    SEE_FOLLOWUP_CASES: true,
    SEE_MANAGE_SIGNATURES: true,
    SEE_USER_EMAILS: true,
    SEE_USER_NAMES: true,
    SEE_ENTITY_SENSITIVE: true,
    SEE_ACTION_POINTS: true,
    DATAROOM_DOWNLOAD_ZIP: true,
    ORGBRAIN_ACADEMY: true,
    DATAROOM_SEE_SHOW_DELETED: true,
    DATAROOM_COPY_FILE: true,
    DATAROOM_SEE_FILE_DETAILS: true,
    DATAROOM_SEE_FILE_HISTORY: true,
    DATAROOM_CREATE_TASK_FROM_FILE: true,
    DATAROOM_SEE_FILE_MENU: true,
    DATAROOM_SET_FILE_STATUS: true,
    CREATE_DD_GROUP: true,
    CREATE_SUB_GROUP: true,
    ACCESS_TO_SECURITY_TAB: true,
    ACCESS_TO_SETTINGS_TAB: true,
    TEMPLATES_ADMIN: true,
    OPENAI_USER: true,
    school: true,
    shareholders: true,
    templates: true,
    files: true,
    surveys: true,
    meetings: true,
    tasks: true,
    chat: true,
    news: true,
    organization: true,
    DATAROOM_ADMIN: true,
    BOARDMATCH_ADMIN: true,
    CONVERSATIONS_LIMITED: true,
    CONVERSATIONS_CREATE: true,
    CONVERSATIONS_ADMIN: true,
    files_lite: true,
    MEETING_AI: true,
  },
  BOARDMEMBER: {
    CAN_VOTE_BOARDMEETING: true,
    CAN_VOTE_IN_THEORY_BOARDMEETING: true,
    ACCESS_TO_BOARD_MEETINGS: true,
    ACCESS_TO_GA_MEETINGS: true,
    ACCESS_TO_NEWS_FOR_BOARD: true,
    VIEW_SHARES: true,
    VIEW_SHARE_ISSUES: true,
    INITIATE_ORGBRAIN_SIGNING: true,
    INITIATE_BANK_ID_SIGNING: true,
    ALLOW_AI_TRANSCRIPTION: true,
    SEE_CYCLIC_CALENDAR: true,
    SEE_FOLLOWUP_CASES: true,
    SEE_MANAGE_SIGNATURES: true,
    SEE_USER_EMAILS: true,
    SEE_USER_NAMES: true,
    SEE_ACTION_POINTS: true,
    ORGBRAIN_ACADEMY: true,
    DATAROOM_COPY_FILE: true,
    DATAROOM_SEE_FILE_DETAILS: true,
    DATAROOM_CREATE_TASK_FROM_FILE: true,
    DATAROOM_SEE_FILE_MENU: true,
    DATAROOM_SET_FILE_STATUS: true,
    ACCESS_TO_NEWS_FOR_SHAREHOLDERS: true,
    OPENAI_USER: true,
    templates: true,
    shareholders: true,
    files: true,
    surveys: true,
    meetings: true,
    tasks: true,
    chat: true,
    school: true,
    news: true,
    CONVERSATIONS_LIMITED: true,
    CONVERSATIONS_CREATE: true,
    files_lite: true,
  },
  CEO: {
    ADMIN: true,
    NEWS_ADMIN: true,
    GA_NEWS_ADMIN: true,
    SHAREHOLDER_ADMIN: true,
    MEETING_ADMIN: true,
    GA_MEETING_ADMIN: true,
    BOARD_MEETING_ADMIN: true,
    TASKS_ADMIN: true,
    ORGANIZATION_ADMIN: true,
    ACCESS_TO_BOARD_MEETINGS: true,
    ACCESS_TO_GA_MEETINGS: true,
    ACCESS_TO_NEWS_FOR_BOARD: true,
    VIEW_SHARES: true,
    VIEW_SHARE_ISSUES: true,
    INITIATE_ORGBRAIN_SIGNING: true,
    INITIATE_BANK_ID_SIGNING: true,
    ALLOW_AI_TRANSCRIPTION: true,
    CREATE_SIGNING_ORDER: true,
    SEE_CYCLIC_CALENDAR: true,
    SEE_FOLLOWUP_CASES: true,
    SEE_MANAGE_SIGNATURES: true,
    SEE_USER_EMAILS: true,
    SEE_USER_NAMES: true,
    SEE_ENTITY_SENSITIVE: true,
    DATAROOM_DOWNLOAD_ZIP: true,
    CREATE_DD_GROUP: true,
    CREATE_SUB_GROUP: true,
    ACCESS_TO_SECURITY_TAB: true,
    ACCESS_TO_SETTINGS_TAB: true,
    ORGBRAIN_ACADEMY: true,
    DATAROOM_SEE_SHOW_DELETED: true,
    DATAROOM_COPY_FILE: true,
    DATAROOM_SEE_FILE_DETAILS: true,
    DATAROOM_SEE_FILE_HISTORY: true,
    DATAROOM_CREATE_TASK_FROM_FILE: true,
    DATAROOM_SEE_FILE_MENU: true,
    DATAROOM_SET_FILE_STATUS: true,
    TEMPLATES_ADMIN: true,
    ACCESS_TO_NEWS_FOR_SHAREHOLDERS: true,
    SEE_ACTION_POINTS: true,
    OPENAI_USER: true,
    shareholders: true,
    templates: true,
    files: true,
    surveys: true,
    meetings: true,
    tasks: true,
    chat: true,
    school: true,
    news: true,
    organization: true,
    DATAROOM_ADMIN: true,
    BOARDMATCH_ADMIN: true,
    CONVERSATIONS_LIMITED: true,
    CONVERSATIONS_CREATE: true,
    CONVERSATIONS_ADMIN: true,
    files_lite: true,
    MEETING_AI: true,
  },
  BOARDSECRETARY: {
    ADMIN: true,
    NEWS_ADMIN: true,
    GA_NEWS_ADMIN: true,
    SHAREHOLDER_ADMIN: true,
    MEETING_ADMIN: true,
    GA_MEETING_ADMIN: true,
    BOARD_MEETING_ADMIN: true,
    TASKS_ADMIN: true,
    ORGANIZATION_ADMIN: true,
    ACCESS_TO_BOARD_MEETINGS: true,
    ACCESS_TO_GA_MEETINGS: true,
    ACCESS_TO_NEWS_FOR_BOARD: true,
    VIEW_SHARES: true,
    VIEW_SHARE_ISSUES: true,
    INITIATE_ORGBRAIN_SIGNING: true,
    INITIATE_BANK_ID_SIGNING: true,
    ALLOW_AI_TRANSCRIPTION: true,
    CREATE_SIGNING_ORDER: true,
    SEE_CYCLIC_CALENDAR: true,
    SEE_FOLLOWUP_CASES: true,
    SEE_MANAGE_SIGNATURES: true,
    SEE_USER_EMAILS: true,
    SEE_USER_NAMES: true,
    SEE_ACTION_POINTS: true,
    SEE_ENTITY_SENSITIVE: true,
    CREATE_DD_GROUP: true,
    CREATE_SUB_GROUP: true,
    ACCESS_TO_SECURITY_TAB: true,
    ACCESS_TO_SETTINGS_TAB: true,
    DATAROOM_DOWNLOAD_ZIP: true,
    ORGBRAIN_ACADEMY: true,
    DATAROOM_SEE_SHOW_DELETED: true,
    DATAROOM_COPY_FILE: true,
    DATAROOM_SEE_FILE_DETAILS: true,
    DATAROOM_SEE_FILE_HISTORY: true,
    DATAROOM_CREATE_TASK_FROM_FILE: true,
    DATAROOM_SEE_FILE_MENU: true,
    DATAROOM_SET_FILE_STATUS: true,
    TEMPLATES_ADMIN: true,
    ACCESS_TO_NEWS_FOR_SHAREHOLDERS: true,
    OPENAI_USER: true,
    templates: true,
    shareholders: true,
    files: true,
    surveys: true,
    meetings: true,
    tasks: true,
    chat: true,
    school: true,
    news: true,
    organization: true,
    DATAROOM_ADMIN: true,
    BOARDMATCH_ADMIN: true,
    CONVERSATIONS_LIMITED: true,
    CONVERSATIONS_CREATE: true,
    CONVERSATIONS_ADMIN: true,
    files_lite: true,
    MEETING_AI: true,
  },
  DEPUTYCHAIR: {
    CAN_VOTE_BOARDMEETING: true,
    CAN_VOTE_IN_THEORY_BOARDMEETING: true,
    ACCESS_TO_BOARD_MEETINGS: true,
    ACCESS_TO_GA_MEETINGS: true,
    ACCESS_TO_NEWS_FOR_BOARD: true,
    VIEW_SHARES: true,
    VIEW_SHARE_ISSUES: true,
    INITIATE_ORGBRAIN_SIGNING: true,
    INITIATE_BANK_ID_SIGNING: true,
    ALLOW_AI_TRANSCRIPTION: true,
    SEE_CYCLIC_CALENDAR: true,
    SEE_FOLLOWUP_CASES: true,
    SEE_MANAGE_SIGNATURES: true,
    SEE_USER_EMAILS: true,
    SEE_USER_NAMES: true,
    SEE_ACTION_POINTS: true,
    ORGBRAIN_ACADEMY: true,
    DATAROOM_COPY_FILE: true,
    DATAROOM_SEE_FILE_DETAILS: true,
    DATAROOM_CREATE_TASK_FROM_FILE: true,
    DATAROOM_SEE_FILE_MENU: true,
    DATAROOM_SET_FILE_STATUS: true,
    ACCESS_TO_NEWS_FOR_SHAREHOLDERS: true,
    OPENAI_USER: true,
    templates: true,
    shareholders: true,
    files: true,
    surveys: true,
    meetings: true,
    tasks: true,
    chat: true,
    school: true,
    news: true,
    CONVERSATIONS_LIMITED: true,
    CONVERSATIONS_CREATE: true,
    files_lite: true,
  },
  DEPUTYMEMBER: {
    ACCESS_TO_BOARD_MEETINGS: true,
    ACCESS_TO_GA_MEETINGS: true,
    ACCESS_TO_NEWS_FOR_BOARD: true,
    VIEW_SHARES: true,
    VIEW_SHARE_ISSUES: true,
    INITIATE_ORGBRAIN_SIGNING: true,
    INITIATE_BANK_ID_SIGNING: true,
    ALLOW_AI_TRANSCRIPTION: true,
    SEE_CYCLIC_CALENDAR: true,
    SEE_FOLLOWUP_CASES: true,
    SEE_MANAGE_SIGNATURES: true,
    SEE_USER_EMAILS: true,
    SEE_USER_NAMES: true,
    ORGBRAIN_ACADEMY: true,
    DATAROOM_COPY_FILE: true,
    CAN_VOTE_IN_THEORY_BOARDMEETING: true,
    DATAROOM_SEE_FILE_DETAILS: true,
    DATAROOM_CREATE_TASK_FROM_FILE: true,
    DATAROOM_SEE_FILE_MENU: true,
    DATAROOM_SET_FILE_STATUS: true,
    ACCESS_TO_NEWS_FOR_SHAREHOLDERS: true,
    SEE_ACTION_POINTS: true,
    OPENAI_USER: true,
    templates: true,
    shareholders: true,
    files: true,
    surveys: true,
    meetings: true,
    tasks: true,
    chat: true,
    school: true,
    news: true,
    CONVERSATIONS_LIMITED: true,
    CONVERSATIONS_CREATE: true,
    files_lite: true,
  },
  OBSERVER: {
    ACCESS_TO_BOARD_MEETINGS: true,
    ACCESS_TO_GA_MEETINGS: true,
    ACCESS_TO_NEWS_FOR_BOARD: true,
    VIEW_SHARES: true,
    VIEW_SHARE_ISSUES: true,
    INITIATE_ORGBRAIN_SIGNING: true,
    INITIATE_BANK_ID_SIGNING: true,
    ALLOW_AI_TRANSCRIPTION: true,
    SEE_CYCLIC_CALENDAR: true,
    SEE_FOLLOWUP_CASES: true,
    SEE_MANAGE_SIGNATURES: true,
    SEE_USER_EMAILS: true,
    SEE_USER_NAMES: true,
    SEE_ACTION_POINTS: true,
    ORGBRAIN_ACADEMY: true,
    CAN_VOTE_IN_THEORY_BOARDMEETING: true,
    ACCESS_TO_NEWS_FOR_SHAREHOLDERS: true,
    OPENAI_USER: true,
    templates: true,
    shareholders: true,
    surveys: true,
    meetings: true,
    tasks: true,
    chat: true,
    school: true,
    news: true,
    files: true,
    CONVERSATIONS_LIMITED: true,
    CONVERSATIONS_CREATE: true,
    files_lite: true,
  },
  SHAREHOLDER: {
    SHAREHOLDER: true,
    shareholders: true,
    VIEW_SHARES: true,
    VIEW_SHARE_ISSUES: true,
    INITIATE_ORGBRAIN_SIGNING: true,
    INITIATE_BANK_ID_SIGNING: true,
    ALLOW_AI_TRANSCRIPTION: true,
    OPENAI_USER: true,
    CONVERSATIONS_LIMITED: true,
    files_lite: true,
  },
  COLLABORATOR: {
    SHAREHOLDER: true,
    shareholders: true,
    VIEW_SHARES: true,
    VIEW_SHARE_ISSUES: true,
    INITIATE_ORGBRAIN_SIGNING: true,
    INITIATE_BANK_ID_SIGNING: true,
    ALLOW_AI_TRANSCRIPTION: true,
    OPENAI_USER: true,
    CONVERSATIONS_LIMITED: true,
    CONVERSATIONS_CREATE: true,
    files_lite: true,
  },

  AUDITOR: {
    ACCESS_TO_BOARD_MEETINGS: true,
    ACCESS_TO_GA_MEETINGS: true,
    VIEW_SHARES: true,
    VIEW_SHARE_ISSUES: true,
    INITIATE_ORGBRAIN_SIGNING: true,
    INITIATE_BANK_ID_SIGNING: true,
    ALLOW_AI_TRANSCRIPTION: true,
    SEE_CYCLIC_CALENDAR: true,
    SEE_ACTION_POINTS: true,
    DATAROOM_DOWNLOAD_ZIP: true,
    ORGBRAIN_ACADEMY: true,
    DATAROOM_COPY_FILE: true,
    DATAROOM_SEE_FILE_DETAILS: true,
    DATAROOM_CREATE_TASK_FROM_FILE: true,
    DATAROOM_SEE_FILE_MENU: true,
    DATAROOM_SET_FILE_STATUS: true,
    ACCESS_TO_NEWS_FOR_SHAREHOLDERS: true,
    SEE_FOLLOWUP_CASES: true,
    OPENAI_USER: true,
    templates: true,
    meetings: true,
    tasks: true,
    shareholders: true,
    files: true,
    surveys: true,
    school: true,
    news: true,
    CONVERSATIONS_LIMITED: true,
    CONVERSATIONS_CREATE: true,
    files_lite: true,
  },
  CONTACTPERSON: { files_lite: true },
  SHAREHOLDER_PROXY: {
    OWNER: true,
    SHAREHOLDER: true,
    VIEW_SHARES: true,
    VIEW_SHARE_ISSUES: true,
    INITIATE_ORGBRAIN_SIGNING: true,
    INITIATE_BANK_ID_SIGNING: true,
    ALLOW_AI_TRANSCRIPTION: true,
    ACCESS_TO_GA_MEETINGS: true,
    ACCESS_TO_NEWS_FOR_SHAREHOLDERS: true,
    DATAROOM_CREATE_TASK_FROM_FILE: true,
    DATAROOM_SEE_FILE_MENU: true,
    DATAROOM_SET_FILE_STATUS: true,
    OPENAI_USER: true,
    files: true,
    shareholders: true,
    meetings: true,
    CONVERSATIONS_LIMITED: true,
    files_lite: true,
  },
  OWNER_ADMIN: {
    GA_MEETING_ADMIN: true,
    ACCESS_TO_GA_MEETINGS: true,
    MEETING_ADMIN: true,
    SHAREHOLDER_ADMIN: true,
    OWNER: true,
    SHAREHOLDER: true,
    INITIATE_ORGBRAIN_SIGNING: true,
    INITIATE_BANK_ID_SIGNING: true,
    ALLOW_AI_TRANSCRIPTION: true,
    ACCESS_TO_NEWS_FOR_SHAREHOLDERS: true,
    GA_NEWS_ADMIN: true,
    DATAROOM_COPY_FILE: true,
    DATAROOM_CREATE_TASK_FROM_FILE: true,
    DATAROOM_SEE_FILE_DETAILS: true,
    DATAROOM_SEE_FILE_MENU: true,
    DATAROOM_SET_FILE_STATUS: true,
    OPENAI_USER: true,
    meetings: true,
    news: true,
    surveys: true,
    CONVERSATIONS_LIMITED: true,
    CONVERSATIONS_CREATE: true,
    CREATE_SIGNING_ORDER: true,
    ORGBRAIN_ACADEMY: true,
    files: true,
    school: true,
    shareholders: true,
    templates: true,
    files_lite: true,
    MEETING_AI: true,
  },

  SCHOOL: {
    ORGBRAIN_ACADEMY: true,
    school: true,
    templates: true,
    OPENAI_USER: true,
    files_lite: true,
  },
  SELLER_ADMIN: {
    SELLER: true,
    CREATE_DD_GROUP: true,
    CREATE_SUB_GROUP: true,
    ACCESS_TO_SECURITY_TAB: true,
    ACCESS_TO_SETTINGS_TAB: true,
    SELLER_ADMIN: true,
    ADMIN: true,
    NEWS_ADMIN: true,
    GA_NEWS_ADMIN: true,
    MEETING_ADMIN: true,
    BOARD_MEETING_ADMIN: true,
    TASKS_ADMIN: true,
    GA_MEETING_ADMIN: true,
    ORGANIZATION_ADMIN: true,
    ACCESS_TO_BOARD_MEETINGS: true,
    ACCESS_TO_GA_MEETINGS: true,
    SEE_FOLLOWUP_CASES: true,
    SEE_USER_EMAILS: true,
    SEE_MANAGE_SIGNATURES: true,
    SEE_USER_NAMES: true,
    SEE_ACTION_POINTS: true,
    SEE_ENTITY_SENSITIVE: true,
    CAN_VOTE_BOARDMEETING: true,
    CAN_VOTE_IN_THEORY_BOARDMEETING: true,
    ACCESS_TO_NEWS_FOR_BOARD: true,
    VIEW_SHARES: true,
    VIEW_SHARE_ISSUES: true,
    INITIATE_ORGBRAIN_SIGNING: true,
    INITIATE_BANK_ID_SIGNING: true,
    ALLOW_AI_TRANSCRIPTION: true,
    CREATE_SIGNING_ORDER: true,
    SEE_CYCLIC_CALENDAR: true,
    DATAROOM_DOWNLOAD_ZIP: true,
    DATAROOM_SEE_SHOW_DELETED: true,
    DATAROOM_COPY_FILE: true,
    DATAROOM_SEE_FILE_DETAILS: true,
    DATAROOM_SEE_FILE_HISTORY: true,
    DATAROOM_CREATE_TASK_FROM_FILE: true,
    DATAROOM_SEE_FILE_MENU: true,
    DATAROOM_SET_FILE_STATUS: true,
    SHAREHOLDER_ADMIN: true,
    TEMPLATES_ADMIN: true,
    OPENAI_USER: true,
    news: true,
    shareholders: true,
    files: true,
    surveys: true,
    meetings: true,
    tasks: true,
    chat: true,
    organization: true,
    DATAROOM_ADMIN: true,
    CONVERSATIONS_LIMITED: true,
    CONVERSATIONS_CREATE: true,
    files_lite: true,
    MEETING_AI: true,
  },
  BUYER_ADMIN: {
    ADMIN: true,
    BUYER: true,
    CREATE_DD_GROUP: true,
    CREATE_SUB_GROUP: true,
    ACCESS_TO_SECURITY_TAB: true,
    ACCESS_TO_SETTINGS_TAB: true,
    BUYER_ADMIN: true,
    ACCESS_TO_BOARD_MEETINGS: true,
    SEE_FOLLOWUP_CASES: true,
    CAN_VOTE_BOARDMEETING: true,
    CAN_VOTE_IN_THEORY_BOARDMEETING: true,
    ACCESS_TO_NEWS_FOR_BOARD: true,
    VIEW_SHARES: true,
    VIEW_SHARE_ISSUES: true,
    INITIATE_ORGBRAIN_SIGNING: true,
    INITIATE_BANK_ID_SIGNING: true,
    ALLOW_AI_TRANSCRIPTION: true,
    SEE_CYCLIC_CALENDAR: true,
    SEE_USER_EMAILS: true,
    SEE_ACTION_POINTS: true,
    DATAROOM_DOWNLOAD_ZIP: true,
    DATAROOM_SEE_FILE_HISTORY: true,
    DATAROOM_CREATE_TASK_FROM_FILE: true,
    DATAROOM_SEE_FILE_MENU: true,
    DATAROOM_SET_FILE_STATUS: true,
    OPENAI_USER: true,
    shareholders: true,
    surveys: true,
    files: true,
    meetings: true,
    tasks: true,
    chat: true,
    CONVERSATIONS_LIMITED: true,
    CONVERSATIONS_CREATE: true,
    files_lite: true,
  },
  BUYER: {
    BUYER: true,
    ACCESS_TO_BOARD_MEETINGS: true,
    SEE_FOLLOWUP_CASES: true,
    CAN_VOTE_BOARDMEETING: true,
    CAN_VOTE_IN_THEORY_BOARDMEETING: true,
    ACCESS_TO_NEWS_FOR_BOARD: true,
    VIEW_SHARES: true,
    VIEW_SHARE_ISSUES: true,
    INITIATE_ORGBRAIN_SIGNING: true,
    INITIATE_BANK_ID_SIGNING: true,
    ALLOW_AI_TRANSCRIPTION: true,
    SEE_CYCLIC_CALENDAR: true,
    SEE_USER_EMAILS: true,
    SEE_ACTION_POINTS: true,
    OPENAI_USER: true,
    shareholders: true,
    surveys: true,
    files: true,
    meetings: true,
    tasks: true,
    chat: true,
    CONVERSATIONS_LIMITED: true,
    CONVERSATIONS_CREATE: true,
    files_lite: true,
  },
  SELLER: {
    SELLER: true,
    MEETING_ADMIN: true,
    BOARD_MEETING_ADMIN: true,
    TASKS_ADMIN: true,
    ACCESS_TO_BOARD_MEETINGS: true,
    SEE_FOLLOWUP_CASES: true,
    SEE_USER_EMAILS: true,
    SEE_MANAGE_SIGNATURES: true,
    SEE_USER_NAMES: true,
    SEE_ACTION_POINTS: true,
    CAN_VOTE_BOARDMEETING: true,
    CAN_VOTE_IN_THEORY_BOARDMEETING: true,
    ACCESS_TO_NEWS_FOR_BOARD: true,
    VIEW_SHARES: true,
    VIEW_SHARE_ISSUES: true,
    INITIATE_ORGBRAIN_SIGNING: true,
    INITIATE_BANK_ID_SIGNING: true,
    ALLOW_AI_TRANSCRIPTION: true,
    CREATE_SIGNING_ORDER: true,
    SEE_CYCLIC_CALENDAR: true,
    DATAROOM_SEE_SHOW_DELETED: true,
    DATAROOM_COPY_FILE: true,
    DATAROOM_SEE_FILE_DETAILS: true,
    DATAROOM_SEE_FILE_HISTORY: true,
    DATAROOM_CREATE_TASK_FROM_FILE: true,
    DATAROOM_SEE_FILE_MENU: true,
    DATAROOM_SET_FILE_STATUS: true,
    OPENAI_USER: true,
    shareholders: true,
    files: true,
    surveys: true,
    meetings: true,
    tasks: true,
    chat: true,
    CONVERSATIONS_LIMITED: true,
    CONVERSATIONS_CREATE: true,
    files_lite: true,
    MEETING_AI: true,
  },
  BOARDMATCH_ADMIN: {
    BOARDMATCH_ADMIN: true,
    files_lite: true,
  },

  ROLE_1: {},
  ROLE_2: {},
  ROLE_3: {},
  ROLE_4: {},
  ROLE_5: {},
  ROLE_6: {},

  // SPORTS ID ROLES
  CASHIER: {},
  // CONTROL_COMMITTEE_CHAIR: {},
  // NOMINATION_COMMITTEE_CHAIR: {},
  POLICE_CERTIFICATE_RESPONSIBLE: {},
  YOUTHSPORTS_MANAGER: {},
};

for (const perm of Object.keys(PermissionEnum)) {
  _defaultRoleMap[Role.ORGBRAIN_SUPPORT][perm] = true;
}
